import React from 'react'
import { t } from './i18n'

export interface INavItem {
  key: string
  url: string
  label: string
  include?: string[]
}

export const navigationTop: INavItem[] = [
  { key: '1', label: t.nav.schedule, url: '/todo1' },
  { key: '2', label: t.nav.appointments, url: '/todo2' },
  { key: '3', label: t.nav.workers, url: '/todo3' },
  { key: '4', label: t.nav.patients, url: '/todo4' },
  { key: '5', label: t.nav.feedback, url: '/todo5' },
]

export const navigationSide: INavItem[] = [
  { key: '6', label: t.nav.dynamicCatalogs, url: '/catalog/dynamic', include: ['/catalog/dynamic'] },
  { key: '7', label: t.nav.singleCatalogs, url: '/catalog/single', include: ['/catalog/single'] },
]
